export const API_SOCKETENDPOINT="https://www.newconcept-group.com:2006"
export const API_ENDPOINT = 'https://maktabtiy.com/maktabtiBackend';  



